import { Controller } from "@hotwired/stimulus";

// Bottom of the public profile pages: clicking a question of the list drops it into the composer
// (the textarea), highlights it, and brings the composer back into view. Submitting is the form's.
export default class extends Controller {
  static targets = ["input", "question"];

  pick(event) {
    const button = event.currentTarget;
    this.inputTarget.value = button.dataset.askInsitiTextParam;
    this.questionTargets.forEach((q) => q.removeAttribute("aria-current"));
    button.setAttribute("aria-current", "true");
    this.inputTarget.focus({ preventScroll: true });
    this.inputTarget.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}
